<template>
  <div class="box content-container container-wide">
    <div class="inner-content allow-scroll">
      <slot></slot>
    </div>
    <slot name="corner-box"></slot>
    <div class="side-bar">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WideBoxSection',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WideBoxSection.vue